<app-data-table
title="Village Agents Account"
url = "users/village-agents"
type = "villageagent"
[hideActionsColumn]="false"
></app-data-table>
